import { render, staticRenderFns } from "./EntePubblico.vue?vue&type=template&id=8e94b4aa&scoped=true"
import script from "./EntePubblico.vue?vue&type=script&lang=ts"
export * from "./EntePubblico.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e94b4aa",
  null
  
)

export default component.exports